import type { Ref } from 'react';
import { NumberStepper } from './NumberStepper';

export interface MoneyInputProps {
  /** Amount in cents (`null` when empty). */
  value: number | null;
  onChange: (cents: number | null) => void;
  /** Step of the buttons in cents (default 50). */
  stepCents?: number;
  labels: { decrement: string; increment: string };
  /** Currency symbol after the number (default `€`). */
  currency?: string;
  locale?: string;
  id?: string;
  invalid?: boolean;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  'aria-describedby'?: string;
  'aria-label'?: string;
  size?: 'sm' | 'md' | 'lg';
  ref?: Ref<HTMLInputElement>;
}

/** Amount entry with two decimals. The value is kept in cents (BE-007). */
export function MoneyInput({
  value,
  onChange,
  stepCents = 50,
  currency = '€',
  ...rest
}: MoneyInputProps) {
  return (
    <NumberStepper
      {...rest}
      value={value === null ? null : value / 100}
      onChange={(v) => onChange(v === null ? null : Math.round(v * 100))}
      min={0}
      step={stepCents / 100}
      decimals={2}
      unit={currency}
    />
  );
}
